import { render } from "./JerarquiaComponent.vue?vue&type=template&id=2fc6608e"
import script from "./JerarquiaComponent.vue?vue&type=script&lang=js"
export * from "./JerarquiaComponent.vue?vue&type=script&lang=js"

import "./JerarquiaComponent.vue?vue&type=style&index=0&id=2fc6608e&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__